import { useEffect, useLayoutEffect, useRef, useState } from "react";
import limitWriting from "../../../app/limitWriting";
import useDebounceFn from "../../../app/useDebounceFn";
import { useAppSelector } from "../../../app/hooks";
import { deserializeOrganizer } from "./organizerHelper";
import "./organizer.css";

interface Props {
	className?: string;
	html: string;
	response: string;
	readonly: boolean;
}

export default function Organizer({ className, html, response, readonly }: Props) {
	const [organizerHtml, setOrganizerHtml] = useState("");
	const { aspUrl } = useAppSelector((state) => state.site);

	const organizerWrapper = useRef<HTMLDivElement | null>(null);

	useLayoutEffect(() => {
		const _dom = deserializeOrganizer(html, response, aspUrl, readonly);
		setOrganizerHtml(_dom.innerHTML);
	}, [html, response, readonly]);

	useEffect(() => {
		const img = organizerWrapper.current?.querySelector(`img`);
		img?.addEventListener("load", resizeOrganizer);

		return () => {
			img?.removeEventListener("load", resizeOrganizer);
		};
	}, [organizerWrapper.current]);

	useLayoutEffect(() => {
		window.addEventListener("resize", resizeOrganizer);

		return () => {
			window.removeEventListener("resize", resizeOrganizer);
		};
	}, []);

	useEffect(() => {
		var organizer = document.querySelector(".organizer");
		var textareas = organizer?.querySelectorAll("textarea");
		limitWriting(textareas, {
			"max-length": 5000,
			"big-change-threshold": 100,
			"handle-tab": false,
		});
		return () => {
			limitWriting(textareas, { unmount: true, "handle-tab": true });
		};
	}, [organizerHtml]);

	const debouncedResize = useDebounceFn(resizeOrganizer, 50);

	function resizeOrganizer() {
		if (!organizerWrapper.current) return;

		const org = organizerWrapper.current;
		const img = org.querySelector(`img`);
		const divs = org.querySelectorAll(`div`);
		const elements = Array.from(divs).filter((d) => d.classList.contains("element"));

		if (!img) return;
		if (elements.length == 0) return;

		const xRatio = img.width / img.naturalWidth;
		const yRatio = img.height / img.naturalHeight;

		elements.forEach((element) => {
			const xTrans = element.offsetLeft * (1 - xRatio);
			const yTrans = element.offsetTop * (1 - yRatio);
			const xScale = 100 * xRatio;
			const yScale = 100 * yRatio;
			const fontScale = 100 * (2 - xRatio);

			element.style.transformOrigin = "top left";
			element.style.translate = `-${xTrans}px -${yTrans}px`;
			element.style.scale = `${xScale}% ${yScale}%`;
			element.style.fontSize = `${fontScale}%`;
		});
	}

	return (
		<div
			ref={organizerWrapper}
			className={`${className} organizerWrapper`}
			dangerouslySetInnerHTML={{
				__html: organizerHtml,
			}}></div>
	);
}
